import { useContext } from "react";
import { MergeFilesContext } from "./MergeFilesProvider";

export default function useMergeFilesContext() {
    return useContext(MergeFilesContext);
};
